const dayFirstFormat = {
    monthAndYear: {
        month: 'numeric', year: 'numeric'
    },
    short: {
        day: 'numeric', month: 'numeric', year: '2-digit',
        hour: 'numeric', minute: 'numeric'
    },
    shortDate: {
        day: 'numeric', month: 'numeric', year: '2-digit'
    },
    default: {
        day: 'numeric', month: 'numeric', year: 'numeric',
        hour: 'numeric', minute: 'numeric'
    },
    defaultDate: {
        day: 'numeric', month: 'numeric', year: 'numeric'
    },
    defaultTime: {
        hour: 'numeric', minute: 'numeric'
    },
    long: {
        day: 'numeric', month: 'long', year: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric'
    },
    longDate: {
        day: 'numeric', month: 'long', year: 'numeric'
    },
    longTime: {
        hour: 'numeric', minute: 'numeric', second: 'numeric'
    }
};
const monthFirstFormat = {
    monthAndYear: {
        month: 'numeric', year: 'numeric'
    },
    short: {
        day: 'numeric', month: 'numeric', year: '2-digit',
        hour: 'numeric', minute: 'numeric',
        hour12: true
    },
    shortDate: {
        day: 'numeric', month: 'numeric', year: '2-digit'
    },
    default: {
        day: 'numeric', month: 'numeric', year: 'numeric',
        hour: 'numeric', minute: 'numeric',
        hour12: true
    },
    defaultDate: {
        day: 'numeric', month: 'numeric', year: 'numeric'
    },
    defaultTime: {
        hour: 'numeric', minute: 'numeric',
        hour12: true
    },
    long: {
        day: 'numeric', month: 'long', year: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: true
    },
    longDate: {
        day: 'numeric', month: 'long', year: 'numeric'
    },
    longTime: {
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: true
    }
};
const dateFormats = {
    'en-US': {
        ...monthFirstFormat
    },
    'en-GB': {
        ...dayFirstFormat
    },
    'de-DE': {
        ...dayFirstFormat
    },
    'fr-FR': {
        ...dayFirstFormat
    },
    'nl-NL': {
        ...dayFirstFormat
    },
    'es-ES': {
        ...dayFirstFormat
    },
    'pl-PL': {
        ...dayFirstFormat
    },
    'en-IE': {
        ...dayFirstFormat
    },
    'en-AU': {
        ...dayFirstFormat
    },
    'en-NZ': {
        ...dayFirstFormat
    },
    'en-CA': {
        ...monthFirstFormat
    },
    'en-SA': {
        ...dayFirstFormat
    }
};

export default dateFormats;
